export enum TrackedQueryType {
    UserInput = "User Input",
    FAQRAQ = "FAQ/RAQ",
    Favorite = "Favorite",
    DropdownSelection = "Dropdown Selection"
}